import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft, Loader2, Tag, Sparkles, Check } from "lucide-react";
import api from "@/lib/api";
import { useVestaMe } from "./VestaViewAs";
import { VestaHeader } from "./VestaHome";
import { COPPER } from "./VestaAuth";

const eur = (v) => Number(v).toLocaleString("it-IT", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });

export default function VestaTariffario() {
  const me = useVestaMe();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [interval, setIntervallo] = useState("year");

  useEffect(() => {
    api.get("/pro/tariffe").then((r) => setData(r.data)).catch(() => setErr(true));
  }, []);

  if (me === null) return <div className="flex min-h-screen items-center justify-center bg-black"><Loader2 className="h-8 w-8 animate-spin" style={{ color: COPPER }} /></div>;
  if (!me.is_admin) return <Navigate to="/vesta/home" replace />;

  const tiers = data?.tiers || [];
  const sconto = data?.sconto_annuale_pct ?? 20;

  return (
    <div className="min-h-screen bg-black text-white" data-testid="vesta-tariffario-page">
      <VestaHeader />
      <main className="mx-auto max-w-5xl px-5 py-12 sm:px-10">
        <Link to="/vesta/home" className="mb-8 inline-flex items-center gap-1 text-xs text-neutral-400 transition-colors hover:text-white" data-testid="vesta-tariffario-back">
          <ArrowLeft className="h-3.5 w-3.5" /> Tutti i servizi
        </Link>
        <div className="mb-2 flex items-center gap-3">
          <Tag className="h-9 w-9" style={{ color: COPPER }} strokeWidth={1.6} />
          <h1 className="font-heading text-3xl font-extrabold tracking-tight sm:text-5xl" data-testid="vesta-tariffario-title">Tariffario Versione Pro</h1>
        </div>
        <p className="mb-8 max-w-2xl text-neutral-400">Prezzi dell'abbonamento <b className="text-neutral-200">Versione Pro</b> per fascia di potenza dell'impianto (kWp). IVA inclusa. Il cliente finale sottoscrive dal proprio portale; l'admin può attivarla anche manualmente (prova gratuita).</p>

        <div className="mb-8 inline-flex rounded-full bg-neutral-900 p-1 ring-1 ring-neutral-800" data-testid="vesta-tariffario-ciclo">
          <button type="button" onClick={() => setIntervallo("month")} data-testid="vesta-tariffario-mensile"
            className={`rounded-full px-5 py-2 text-sm font-bold transition-colors ${interval === "month" ? "text-black" : "text-neutral-300"}`}
            style={interval === "month" ? { background: COPPER } : undefined}>Mensile</button>
          <button type="button" onClick={() => setIntervallo("year")} data-testid="vesta-tariffario-annuale"
            className={`rounded-full px-5 py-2 text-sm font-bold transition-colors ${interval === "year" ? "text-black" : "text-neutral-300"}`}
            style={interval === "year" ? { background: COPPER } : undefined}>Annuale <span className="font-extrabold">−{sconto}%</span></button>
        </div>

        {err ? (
          <p className="py-20 text-center text-neutral-500" data-testid="vesta-tariffario-error">Tariffario non disponibile al momento.</p>
        ) : !data ? (
          <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin" style={{ color: COPPER }} /></div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="vesta-tariffario-tiers">
            {tiers.map((t) => {
              const prezzo = interval === "year" ? t.yearly_per_month : t.monthly;
              return (
                <div key={t.key} className="flex flex-col rounded-2xl border border-neutral-800 bg-neutral-950 p-5 transition-colors hover:border-[#C17F59]" data-testid={`vesta-tariffario-tier-${t.key}`}>
                  <div className="flex items-center gap-2">
                    <Sparkles className="h-4 w-4" style={{ color: COPPER }} />
                    <span className="font-heading text-lg font-extrabold text-white">{t.label}</span>
                  </div>
                  <div className="mt-0.5 text-xs font-semibold uppercase tracking-wider text-neutral-500">{t.range}</div>
                  <div className="mt-4 flex items-end gap-1">
                    <span className="font-heading text-4xl font-extrabold text-white" data-testid={`vesta-tariffario-prezzo-${t.key}`}>{eur(prezzo)} €</span>
                    <span className="pb-1.5 text-sm font-semibold text-neutral-400">/mese</span>
                  </div>
                  <p className="mt-1 text-xs text-neutral-500">
                    {interval === "year" ? `Fatturato ${eur(t.yearly)} € all'anno` : "Addebito mensile · disdici quando vuoi"}
                  </p>
                  <div className="mt-3 border-t border-neutral-800 pt-3 text-xs text-neutral-400">
                    <span className="inline-flex items-center gap-1.5"><Check className="h-3.5 w-3.5" style={{ color: COPPER }} />Mensile {eur(t.monthly)} € · Annuale {eur(t.yearly)} €</span>
                  </div>
                </div>
              );
            })}
            <div className="flex flex-col justify-center rounded-2xl border border-dashed border-neutral-800 bg-neutral-950/50 p-5 text-center" data-testid="vesta-tariffario-oltre">
              <div className="font-heading text-lg font-extrabold text-neutral-300">Oltre 1 MW</div>
              <p className="mt-1 text-xs text-neutral-500">Tariffa dedicata su richiesta: contatta Torri.</p>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
